import { styled } from "styled-components";
import BlogList from "../Blog/BlogList";
import LatestBlog from "../Blog/LatestBlog";

function Home() {
  return (
    <HomeWrapper>
      <Inner className="layoutWrapper">
        <LatestBlog />
        <BlogList />
      </Inner>
    </HomeWrapper>
  );
}

export default Home;

const HomeWrapper = styled.section``;

const Inner = styled.section`
  margin: 0 auto;
  padding-top: 20px;
  padding-bottom: 10px;
`;
